import "../models/visit_type_rule_selection.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Collections ??= {};

AppointmentBooking.Wizard.Collections.VisitTypeRuleSelections = class VisitTypeRuleSelections extends (
  Backbone.Collection
) {};
AppointmentBooking.Wizard.Collections.VisitTypeRuleSelections.prototype.model =
  AppointmentBooking.Wizard.Models.VisitTypeRuleSelection;
